const EMPTY_RECORDS = Object.freeze({});
const EMPTY_LIST = Object.freeze([]);

export const selectPulmonologyRecords = (state, patientId, resource) =>
  state.pulmonology?.byPatient?.[String(patientId)]?.[resource] || EMPTY_LIST;

export const selectPulmonologyPatientRecords = (state, patientId) =>
  state.pulmonology?.byPatient?.[String(patientId)] || EMPTY_RECORDS;

export const selectPulmonologyLoading = (state) => Boolean(state.pulmonology?.loading);
export const selectPulmonologySaving = (state) => Boolean(state.pulmonology?.saving);
export const selectPulmonologyError = (state) => state.pulmonology?.error || null;